import { useEffect, useState } from 'react';
import {
	Button,
	useToast,
	useDisclosure,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalFooter,
	ModalCloseButton,
	Image,
	Flex,
	Text,
} from '@chakra-ui/react';
import { useWriteContract, useWaitForTransactionReceipt } from 'wagmi';
import ScrollStatKey from '../../assets/abis/ScrollStatKey.json';
import { ethers } from 'ethers';
import api from '../../utils/axios';
import { useUser } from '../../context/UserContext';
import burnKeyImageCatGif from '../../assets/images/png/burn-key.png';

const BurnButton = ({ tokenId, getMintKeys }) => {
	const toast = useToast();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [isCheckBackendBurnEvent, setIsCheckBackendBurnEvent] = useState(false);
	const contractAddress = process.env.REACT_APP_COLLECTION_ADDRESS;
	const { refreshUserData } = useUser();
	const { data: hash, writeContract, error: txError, status: transactionStatus, isLoading, isSuccess } = useWriteContract();

	const { isLoading: isConfirming, isSuccess: isConfirmed, data } =
		useWaitForTransactionReceipt({
			hash,
		})

	const handleBurn = async () => {
		try {
			await writeContract({
				address: contractAddress,
				abi: ScrollStatKey.abi,
				functionName: 'burn',
				args: [tokenId],
			});
		} catch (error) {
			toast({
				title: 'Burn failed!',
				description: `Error: ${error.message}`,
				status: 'error',
				duration: 9000,
				isClosable: true,
			});
		}
	};

	const iface = new ethers.Interface(ScrollStatKey.abi);

	useEffect(() => {
		if (hash && isConfirmed) {
			try {
				const parsedLog = iface.parseLog(data.logs[0]);
				const tokenId = parsedLog.args.id.toString();

				const checkBackendMintData = async (tokenId) => {
					try {
						const response = await api.get(`/user/check-burn?tokenId=${tokenId}`);
						if (response.data.mintedKey === false) {
							setIsCheckBackendBurnEvent(true);
							refreshUserData()
							getMintKeys()
							toast({
								title: 'Burn successful!',
								status: 'success',
								duration: 9000,
								isClosable: true
							});
						}
					} catch (apiError) {
						console.error('Error checking backend burn data:', apiError);
					}
				};

				if (tokenId) {
					checkBackendMintData(tokenId);
				}
			} catch (parseError) {
				console.error('Error parsing log data:', parseError);
				toast({
					title: 'Burn failed!',
					description: `Error: ${parseError}`,
					status: 'error',
					duration: 9000,
					isClosable: true
				});
			}
		}
	}, [isConfirming, isConfirmed, hash, isSuccess]);

	return (
		<>
			<Button
				w="80%"
				mb={8}
				colorScheme="red"
				onClick={onOpen}
				isLoading={(transactionStatus === 'pending' && !isSuccess) || (transactionStatus === 'success' && !isCheckBackendBurnEvent)}
			>
				Burn
			</Button>

			<Modal isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Confirm Burn</ModalHeader>
					<ModalCloseButton />
					<ModalBody>

						<Flex justifyContent={"center"}>
							<Image src={burnKeyImageCatGif}></Image>
						</Flex>
						<Text textAlign={"center"} pt={4}>If you burn this key, you will lose access to all associated features.</Text>
					</ModalBody>
					<ModalFooter>
						<Button colorScheme="orange" mr={3} onClick={() => {
							handleBurn();
							onClose();
						}}>
							Confirm
						</Button>
						<Button variant="ghost" onClick={onClose}>Cancel</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
};

export default BurnButton;
